import { useEffect } from "react";
import { SetOfflineVoucherListAtom, GetOfflineVoucherListAtom } from "../../store/voucherAtom";
import { Link } from "react-router-dom";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";





const columns = [
  {
    title: 'S/N',
    key: 'sn',
    dataIndex: 'sn',
  className: "text-primary",
  sorter: (a, b) => (a?.sn ?? '') - (b?.sn ?? '')
  },

  {
    title: ' Date',
    // key: 'id',
    dataIndex: 'Voucher_Number',
  className: "text-primary Voucher_Number-bold",
  className: "text-primary",
  sorter: (a, b) => (a?.Voucher_Number ?? '').localeCompare(b?.Voucher_Number ?? '')

  },
    
  {
    title: "Redeemed Date",
    dataIndex: "Redeem_Date",
    sorter: (a, b) => (a?.Redeem_Date ?? '').localeCompare(b?.Redeem_Date ?? '')

  },

  {
    title: "Recipient Name",
    dataIndex: "Reciepient_Name",
    sorter: (a, b) => (a?.Reciepient_Name ?? '').localeCompare(b?.Reciepient_Name ?? ''),


  },
  {
    title: "Recipient Mobile Number",
    dataIndex: "Reciepient_Mobile_Number",
    sorter: (a, b) => (a?.Reciepient_Mobile_Number ?? '').localeCompare(b?.Reciepient_Mobile_Number ?? ''),
  

  },
  {
    title: "Recipient Email",
    dataIndex: "Reciepient_Email_Address",
    sorter: (a, b) => (a?.Reciepient_Email_Address ?? '').localeCompare(b?.Reciepient_Email_Address ?? ''),
  

  },
  {
    title: "Voucher Amount (₦)",
    dataIndex: "Voucher_Amount",
    sorter: (a, b) => (a?.Voucher_Amount ?? '').localeCompare(b?.Voucher_Amount ?? ''),
    render: (record) => <span> {formatCustomNumber(record)} </span>

  },
  {
    title: "Redeemed Officer",
    dataIndex: "Created_By_Name",
    sorter: (a, b) => (a?.Created_By_Name ?? '').localeCompare(b?.Created_By_Name ?? '')

  },


];



function VoucherOfflinePage() {
  const setVoucherList =  SetOfflineVoucherListAtom();
  const getVoucherList =  GetOfflineVoucherListAtom();
  const navigate = useNavigate();
  const { pathname } = useLocation();  
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  

  useEffect(()=> {
    // voucherService.getVoucherOffline().then( res => {
    //   if(res.data?.length){
    //     setVoucherList(res.data);

    //   }
    // });


  },[]);

  const createNewVoucher = () => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }


  function handleRowClick(voucher) {
    const id = voucher['Ref_No'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
}



  return (
      <>
      <div className=" b">
      <section className="">
       
     
   
     <div className="flex justify-end w-full  "  >
          <button onClick={()=> createNewVoucher()}
                style={{ backgroundColor: "#476EF8" }}
                className="  rounded text-white text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3"
              >
                New Redeem
              </button>
          </div>

     
      

                <section className="mt-5">
                  <GeneralCustomTable
                      tableHeadList={columns} 
                      tableDataList={getVoucherList}
                      allowCheckBox={false} // show checkBox for each row
                      setSelectedRows={(sel)=> console.log(sel) }
                      rowKey={(record) => record.sn} // custom key
                      handleRowClick={handleRowClick} />
                   </section>

      </section>
    </div>
     
      </>
  
  );
}

export default VoucherOfflinePage;
